import React, { useState } from 'react';
import { api } from '../services/api';

const ApiTest: React.FC = () => {
    const [result, setResult] = useState<string>('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const testApi = async () => {
        setLoading(true);
        setError('');
        setResult('');

        try {
            console.log('Testing API connection...');
            const response = await api.getMasterGrammarCount('nouns');
            setResult(`Success: ${response}`);
            console.log('API test successful:', response);
        } catch (err: any) {
            const errorMessage = err.message || 'Unknown error';
            setError(`Error: ${errorMessage}`);
            console.error('API test failed:', err);
        } finally {
            setLoading(false);
        }
    };

    const testHealth = async () => {
        setLoading(true);
        setError('');
        setResult('');

        try {
            console.log('Testing health endpoint...');
            const response = await fetch('http://localhost:3001/api/health');
            const data = await response.json();
            setResult(`Health check: ${JSON.stringify(data)}`);
            console.log('Health check successful:', data);
        } catch (err: any) {
            const errorMessage = err.message || 'Unknown error';
            setError(`Health check error: ${errorMessage}`);
            console.error('Health check failed:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4 border rounded-lg bg-gray-50">
            <h3 className="text-lg font-semibold mb-4">API Connection Test</h3>

            <div className="space-y-4">
                <button
                    onClick={testApi}
                    disabled={loading}
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
                >
                    {loading ? 'Testing...' : 'Test API Service'}
                </button>

                <button
                    onClick={testHealth}
                    disabled={loading}
                    className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-50 ml-2"
                >
                    {loading ? 'Testing...' : 'Test Health Endpoint'}
                </button>

                {result && (
                    <div className="p-3 bg-green-100 border border-green-300 rounded">
                        <strong>Success:</strong> {result}
                    </div>
                )}

                {error && (
                    <div className="p-3 bg-red-100 border border-red-300 rounded">
                        <strong>Error:</strong> {error}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ApiTest; 